import axios from "axios";

export class BaseRestfulService {
    constructor() {
        this.httpClient = axios;
    }

    getAuthorizationToken() {
        return localStorage.getItem("token");
    }

    async get(url, params) {
        const result = await this.httpClient.request({
            ...params,
            url,
            method: "GET",
            headers: this.getAuthorizationToken()
                ? { authorization: `Bearer ${this.getAuthorizationToken()}` }
                : {},
        });
        return result.data;
    }

    async post(url, data, params) {
        const result = await this.httpClient.request({
            ...params,
            url,
            method: "POST",
            data,
            headers: this.getAuthorizationToken()
                ? { authorization: `Bearer ${this.getAuthorizationToken()}` }
                : {},
        });
        return result.data;
    }

    async put(url, data, params) {
        const result = await this.httpClient.request({
            ...params,
            url,
            method: "PUT",
            data,
            headers: this.getAuthorizationToken()
                ? { authorization: `Bearer ${this.getAuthorizationToken()}` }
                : {},
        });
        return result.data;
    }

    async patch(url, data, params) {
        const result = await this.httpClient.request({
            ...params,
            url,
            method: "PATCH",
            data,
            headers: this.getAuthorizationToken()
                ? { authorization: `Bearer ${this.getAuthorizationToken()}` }
                : {},
        });
        return result.data;
    }

    async del(url, data, params) {
        const result = await this.httpClient.request({
            ...params,
            url,
            data,
            method: "DELETE",
            headers: this.getAuthorizationToken()
                ? { authorization: `Bearer ${this.getAuthorizationToken()}` }
                : {},
        });
        return result.data;
    }
}
